import { IStep } from "../../types/commonTypes";
import { IAddress } from "../types/LeadRequisitionType";

export const INITIAL_ADDRESS: IAddress = {
  streetName: "",
  city: "",
  state: "",
  country: "",
  zipcode: "",
};

export const errorCode = [404, 400, 500];

export const INIT_STEPS: IStep[] = [
  {
    step: 1,
    type: "institution",
    title: "Company Information",
    completed: false,
    active: false,
  },
  {
    step: 2,
    title: "Contact Information",
    type: "profile-o",
    completed: false,
    active: false,
  },
  {
    step: 3,
    title: "Business Needs",
    type: "folders-o",
    subHeader: "Tell us what you want to accomplish with your bank. Choose at least one option.",
    completed: false,
    active: false,
  },
  {
    step: 4,
    title: "Review",
    type: "edit",
    subHeader: "Please review the information you have provided and press Submit",
    completed: false,
    active: false,
  },
];

export const referralSource = [
  "Social Media",
  "Partner Website",
  "Other Citi Line of Business",
  "Another Company",
  "Other",
]

export const referralSource_CitiPartner = ["Citi Partner"];
export const CitiPartner_Options = ["NAVAN"];

export const countrycodelist =
  [
    {
      "label": "Afghanistan",
      "dial_code_label": "+93",
      "value": "93",
      "country_code": "AF"
    },
    {
      "label": "Aland Islands",
      "dial_code_label": "+358",
      "value": "358",
      "country_code": "AX"
    },
    {
      "label": "Albania",
      "dial_code_label": "+355",
      "value": "355",
      "country_code": "AL"
    },
    {
      "label": "Algeria",
      "dial_code_label": "+213",
      "value": "213",
      "country_code": "DZ"
    },
    {
      "label": "American Samoa",
      "dial_code_label": "+1684",
      "value": "1684",
      "country_code": "AS"
    },
    {
      "label": "Andorra",
      "dial_code_label": "+376",
      "value": "376",
      "country_code": "AD"
    },
    {
      "label": "Angola",
      "dial_code_label": "+244",
      "value": "244",
      "country_code": "AO"
    },
    {
      "label": "Anguilla",
      "dial_code_label": "+1264",
      "value": "1264",
      "country_code": "AI"
    },
    {
      "label": "Antarctica",
      "dial_code_label": "+672",
      "value": "672",
      "country_code": "AQ"
    },
    {
      "label": "Antigua and Barbuda",
      "dial_code_label": "+1268",
      "value": "1268",
      "country_code": "AG"
    },
    {
      "label": "Argentina",
      "dial_code_label": "+54",
      "value": "54",
      "country_code": "AR"
    },
    {
      "label": "Armenia",
      "dial_code_label": "+374",
      "value": "374",
      "country_code": "AM"
    },
    {
      "label": "Aruba",
      "dial_code_label": "+297",
      "value": "297",
      "country_code": "AW"
    },
    {
      "label": "Australia",
      "dial_code_label": "+61",
      "value": "61",
      "country_code": "AU"
    },
    {
      "label": "Austria",
      "dial_code_label": "+43",
      "value": "43",
      "country_code": "AT"
    },
    {
      "label": "Azerbaijan",
      "dial_code_label": "+994",
      "value": "994",
      "country_code": "AZ"
    },
    {
      "label": "Bahamas",
      "dial_code_label": "+1242",
      "value": "1242",
      "country_code": "BS"
    },
    {
      "label": "Bahrain",
      "dial_code_label": "+973",
      "value": "973",
      "country_code": "BH"
    },
    {
      "label": "Bangladesh",
      "dial_code_label": "+880",
      "value": "880",
      "country_code": "BD"
    },
    {
      "label": "Barbados",
      "dial_code_label": "+1246",
      "value": "1246",
      "country_code": "BB"
    },
    {
      "label": "Belarus",
      "dial_code_label": "+375",
      "value": "375",
      "country_code": "BY"
    },
    {
      "label": "Belgium",
      "dial_code_label": "+32",
      "value": "32",
      "country_code": "BE"
    },
    {
      "label": "Belize",
      "dial_code_label": "+501",
      "value": "501",
      "country_code": "BZ"
    },
    {
      "label": "Benin",
      "dial_code_label": "+229",
      "value": "229",
      "country_code": "BJ"
    },
    {
      "label": "Bermuda",
      "dial_code_label": "+1441",
      "value": "1441",
      "country_code": "BM"
    },
    {
      "label": "Bhutan",
      "dial_code_label": "+975",
      "value": "975",
      "country_code": "BT"
    },
    {
      "label": "Bolivia, Plurinational State of bolivia",
      "dial_code_label": "+591",
      "value": "591",
      "country_code": "BO"
    },
    {
      "label": "Bosnia and Herzegovina",
      "dial_code_label": "+387",
      "value": "387",
      "country_code": "BA"
    },
    {
      "label": "Botswana",
      "dial_code_label": "+267",
      "value": "267",
      "country_code": "BW"
    },
    {
      "label": "Bouvet Island",
      "dial_code_label": "+47",
      "value": "47",
      "country_code": "BV"
    },
    {
      "label": "Brazil",
      "dial_code_label": "+55",
      "value": "55",
      "country_code": "BR"
    },
    {
      "label": "British Indian Ocean Territory",
      "dial_code_label": "+246",
      "value": "246",
      "country_code": "IO"
    },
    {
      "label": "Brunei Darussalam",
      "dial_code_label": "+673",
      "value": "673",
      "country_code": "BN"
    },
    {
      "label": "Bulgaria",
      "dial_code_label": "+359",
      "value": "359",
      "country_code": "BG"
    },
    {
      "label": "Burkina Faso",
      "dial_code_label": "+226",
      "value": "226",
      "country_code": "BF"
    },
    {
      "label": "Burundi",
      "dial_code_label": "+257",
      "value": "257",
      "country_code": "BI"
    },
    {
      "label": "Cambodia",
      "dial_code_label": "+855",
      "value": "855",
      "country_code": "KH"
    },
    {
      "label": "Cameroon",
      "dial_code_label": "+237",
      "value": "237",
      "country_code": "CM"
    },
    {
      "label": "Canada",
      "dial_code_label": "+1",
      "value": "1",
      "country_code": "CA"
    },
    {
      "label": "Cape Verde",
      "dial_code_label": "+238",
      "value": "238",
      "country_code": "CV"
    },
    {
      "label": "Cayman Islands",
      "dial_code_label": "+345",
      "value": "345",
      "country_code": "KY"
    },
    {
      "label": "Central African Republic",
      "dial_code_label": "+236",
      "value": "236",
      "country_code": "CF"
    },
    {
      "label": "Chad",
      "dial_code_label": "+235",
      "value": "235",
      "country_code": "TD"
    },
    {
      "label": "Chile",
      "dial_code_label": "+56",
      "value": "56",
      "country_code": "CL"
    },
    {
      "label": "China",
      "dial_code_label": "+86",
      "value": "86",
      "country_code": "CN"
    },
    {
      "label": "Christmas Island",
      "dial_code_label": "+61",
      "value": "61",
      "country_code": "CX"
    },
    {
      "label": "Cocos (Keeling) Islands",
      "dial_code_label": "+61",
      "value": "61",
      "country_code": "CC"
    },
    {
      "label": "Colombia",
      "dial_code_label": "+57",
      "value": "57",
      "country_code": "CO"
    },
    {
      "label": "Comoros",
      "dial_code_label": "+269",
      "value": "269",
      "country_code": "KM"
    },
    {
      "label": "Congo",
      "dial_code_label": "+242",
      "value": "242",
      "country_code": "CG"
    },
    {
      "label": "Congo, The Democratic Republic of the Congo",
      "dial_code_label": "+243",
      "value": "243",
      "country_code": "CD"
    },
    {
      "label": "Cook Islands",
      "dial_code_label": "+682",
      "value": "682",
      "country_code": "CK"
    },
    {
      "label": "Costa Rica",
      "dial_code_label": "+506",
      "value": "506",
      "country_code": "CR"
    },
    {
      "label": "Cote d'Ivoire",
      "dial_code_label": "+225",
      "value": "225",
      "country_code": "CI"
    },
    {
      "label": "Croatia",
      "dial_code_label": "+385",
      "value": "385",
      "country_code": "HR"
    },
    {
      "label": "Cuba",
      "dial_code_label": "+53",
      "value": "53",
      "country_code": "CU"
    },
    {
      "label": "Cyprus",
      "dial_code_label": "+357",
      "value": "357",
      "country_code": "CY"
    },
    {
      "label": "Czech Republic",
      "dial_code_label": "+420",
      "value": "420",
      "country_code": "CZ"
    },
    {
      "label": "Denmark",
      "dial_code_label": "+45",
      "value": "45",
      "country_code": "DK"
    },
    {
      "label": "Djibouti",
      "dial_code_label": "+253",
      "value": "253",
      "country_code": "DJ"
    },
    {
      "label": "Dominica",
      "dial_code_label": "+1767",
      "value": "1767",
      "country_code": "DM"
    },
    {
      "label": "Dominican Republic",
      "dial_code_label": "+1849",
      "value": "1849",
      "country_code": "DO"
    },
    {
      "label": "Ecuador",
      "dial_code_label": "+593",
      "value": "593",
      "country_code": "EC"
    },
    {
      "label": "Egypt",
      "dial_code_label": "+20",
      "value": "20",
      "country_code": "EG"
    },
    {
      "label": "El Salvador",
      "dial_code_label": "+503",
      "value": "503",
      "country_code": "SV"
    },
    {
      "label": "Equatorial Guinea",
      "dial_code_label": "+240",
      "value": "240",
      "country_code": "GQ"
    },
    {
      "label": "Eritrea",
      "dial_code_label": "+291",
      "value": "291",
      "country_code": "ER"
    },
    {
      "label": "Estonia",
      "dial_code_label": "+372",
      "value": "372",
      "country_code": "EE"
    },
    {
      "label": "Ethiopia",
      "dial_code_label": "+251",
      "value": "251",
      "country_code": "ET"
    },
    {
      "label": "Falkland Islands (Malvinas)",
      "dial_code_label": "+500",
      "value": "500",
      "country_code": "FK"
    },
    {
      "label": "Faroe Islands",
      "dial_code_label": "+298",
      "value": "298",
      "country_code": "FO"
    },
    {
      "label": "Fiji",
      "dial_code_label": "+679",
      "value": "679",
      "country_code": "FJ"
    },
    {
      "label": "Finland",
      "dial_code_label": "+358",
      "value": "358",
      "country_code": "FI"
    },
    {
      "label": "France",
      "dial_code_label": "+33",
      "value": "33",
      "country_code": "FR"
    },
    {
      "label": "French Guiana",
      "dial_code_label": "+594",
      "value": "594",
      "country_code": "GF"
    },
    {
      "label": "French Polynesia",
      "dial_code_label": "+689",
      "value": "689",
      "country_code": "PF"
    },
    {
      "label": "French Southern Territories",
      "dial_code_label": "+262",
      "value": "262",
      "country_code": "TF"
    },
    {
      "label": "Gabon",
      "dial_code_label": "+241",
      "value": "241",
      "country_code": "GA"
    },
    {
      "label": "Gambia",
      "dial_code_label": "+220",
      "value": "220",
      "country_code": "GM"
    },
    {
      "label": "Georgia",
      "dial_code_label": "+995",
      "value": "995",
      "country_code": "GE"
    },
    {
      "label": "Germany",
      "dial_code_label": "+49",
      "value": "49",
      "country_code": "DE"
    },
    {
      "label": "Ghana",
      "dial_code_label": "+233",
      "value": "233",
      "country_code": "GH"
    },
    {
      "label": "Gibraltar",
      "dial_code_label": "+350",
      "value": "350",
      "country_code": "GI"
    },
    {
      "label": "Greece",
      "dial_code_label": "+30",
      "value": "30",
      "country_code": "GR"
    },
    {
      "label": "Greenland",
      "dial_code_label": "+299",
      "value": "299",
      "country_code": "GL"
    },
    {
      "label": "Grenada",
      "dial_code_label": "+1473",
      "value": "1473",
      "country_code": "GD"
    },
    {
      "label": "Guadeloupe",
      "dial_code_label": "+590",
      "value": "590",
      "country_code": "GP"
    },
    {
      "label": "Guam",
      "dial_code_label": "+1671",
      "value": "1671",
      "country_code": "GU"
    },
    {
      "label": "Guatemala",
      "dial_code_label": "+502",
      "value": "502",
      "country_code": "GT"
    },
    {
      "label": "Guernsey",
      "dial_code_label": "+44",
      "value": "44",
      "country_code": "GG"
    },
    {
      "label": "Guinea",
      "dial_code_label": "+224",
      "value": "224",
      "country_code": "GN"
    },
    {
      "label": "Guinea-Bissau",
      "dial_code_label": "+245",
      "value": "245",
      "country_code": "GW"
    },
    {
      "label": "Guyana",
      "dial_code_label": "+592",
      "value": "592",
      "country_code": "GY"
    },
    {
      "label": "Haiti",
      "dial_code_label": "+509",
      "value": "509",
      "country_code": "HT"
    },
    {
      "label": "Heard Island and Mcdonald Islands",
      "dial_code_label": "+0",
      "value": "0",
      "country_code": "HM"
    },
    {
      "label": "Holy See (Vatican City State)",
      "dial_code_label": "+379",
      "value": "379",
      "country_code": "VA"
    },
    {
      "label": "Honduras",
      "dial_code_label": "+504",
      "value": "504",
      "country_code": "HN"
    },
    {
      "label": "Hong Kong",
      "dial_code_label": "+852",
      "value": "852",
      "country_code": "HK"
    },
    {
      "label": "Hungary",
      "dial_code_label": "+36",
      "value": "36",
      "country_code": "HU"
    },
    {
      "label": "Iceland",
      "dial_code_label": "+354",
      "value": "354",
      "country_code": "IS"
    },
    {
      "label": "India",
      "dial_code_label": "+91",
      "value": "91",
      "country_code": "IN"
    },
    {
      "label": "Indonesia",
      "dial_code_label": "+62",
      "value": "62",
      "country_code": "ID"
    },
    {
      "label": "Iran, Islamic Republic of Persian Gulf",
      "dial_code_label": "+98",
      "value": "98",
      "country_code": "IR"
    },
    {
      "label": "Iraq",
      "dial_code_label": "+964",
      "value": "964",
      "country_code": "IQ"
    },
    {
      "label": "Ireland",
      "dial_code_label": "+353",
      "value": "353",
      "country_code": "IE"
    },
    {
      "label": "Isle of Man",
      "dial_code_label": "+44",
      "value": "44",
      "country_code": "IM"
    },
    {
      "label": "Israel",
      "dial_code_label": "+972",
      "value": "972",
      "country_code": "IL"
    },
    {
      "label": "Italy",
      "dial_code_label": "+39",
      "value": "39",
      "country_code": "IT"
    },
    {
      "label": "Jamaica",
      "dial_code_label": "+1876",
      "value": "1876",
      "country_code": "JM"
    },
    {
      "label": "Japan",
      "dial_code_label": "+81",
      "value": "81",
      "country_code": "JP"
    },
    {
      "label": "Jersey",
      "dial_code_label": "+44",
      "value": "44",
      "country_code": "JE"
    },
    {
      "label": "Jordan",
      "dial_code_label": "+962",
      "value": "962",
      "country_code": "JO"
    },
    {
      "label": "Kazakhstan",
      "dial_code_label": "+7",
      "value": "7",
      "country_code": "KZ"
    },
    {
      "label": "Kenya",
      "dial_code_label": "+254",
      "value": "254",
      "country_code": "KE"
    },
    {
      "label": "Kiribati",
      "dial_code_label": "+686",
      "value": "686",
      "country_code": "KI"
    },
    {
      "label": "Korea, Democratic People's Republic of Korea",
      "dial_code_label": "+850",
      "value": "850",
      "country_code": "KP"
    },
    {
      "label": "Korea, Republic of South Korea",
      "dial_code_label": "+82",
      "value": "82",
      "country_code": "KR"
    },
    {
      "label": "Kosovo",
      "dial_code_label": "+383",
      "value": "383",
      "country_code": "XK"
    },
    {
      "label": "Kuwait",
      "dial_code_label": "+965",
      "value": "965",
      "country_code": "KW"
    },
    {
      "label": "Kyrgyzstan",
      "dial_code_label": "+996",
      "value": "996",
      "country_code": "KG"
    },
    {
      "label": "Laos",
      "dial_code_label": "+856",
      "value": "856",
      "country_code": "LA"
    },
    {
      "label": "Latvia",
      "dial_code_label": "+371",
      "value": "371",
      "country_code": "LV"
    },
    {
      "label": "Lebanon",
      "dial_code_label": "+961",
      "value": "961",
      "country_code": "LB"
    },
    {
      "label": "Lesotho",
      "dial_code_label": "+266",
      "value": "266",
      "country_code": "LS"
    },
    {
      "label": "Liberia",
      "dial_code_label": "+231",
      "value": "231",
      "country_code": "LR"
    },
    {
      "label": "Libyan Arab Jamahiriya",
      "dial_code_label": "+218",
      "value": "218",
      "country_code": "LY"
    },
    {
      "label": "Liechtenstein",
      "dial_code_label": "+423",
      "value": "423",
      "country_code": "LI"
    },
    {
      "label": "Lithuania",
      "dial_code_label": "+370",
      "value": "370",
      "country_code": "LT"
    },
    {
      "label": "Luxembourg",
      "dial_code_label": "+352",
      "value": "352",
      "country_code": "LU"
    },
    {
      "label": "Macao",
      "dial_code_label": "+853",
      "value": "853",
      "country_code": "MO"
    },
    {
      "label": "Macedonia",
      "dial_code_label": "+389",
      "value": "389",
      "country_code": "MK"
    },
    {
      "label": "Madagascar",
      "dial_code_label": "+261",
      "value": "261",
      "country_code": "MG"
    },
    {
      "label": "Malawi",
      "dial_code_label": "+265",
      "value": "265",
      "country_code": "MW"
    },
    {
      "label": "Malaysia",
      "dial_code_label": "+60",
      "value": "60",
      "country_code": "MY"
    },
    {
      "label": "Maldives",
      "dial_code_label": "+960",
      "value": "960",
      "country_code": "MV"
    },
    {
      "label": "Mali",
      "dial_code_label": "+223",
      "value": "223",
      "country_code": "ML"
    },
    {
      "label": "Malta",
      "dial_code_label": "+356",
      "value": "356",
      "country_code": "MT"
    },
    {
      "label": "Marshall Islands",
      "dial_code_label": "+692",
      "value": "692",
      "country_code": "MH"
    },
    {
      "label": "Martinique",
      "dial_code_label": "+596",
      "value": "596",
      "country_code": "MQ"
    },
    {
      "label": "Mauritania",
      "dial_code_label": "+222",
      "value": "222",
      "country_code": "MR"
    },
    {
      "label": "Mauritius",
      "dial_code_label": "+230",
      "value": "230",
      "country_code": "MU"
    },
    {
      "label": "Mayotte",
      "dial_code_label": "+262",
      "value": "262",
      "country_code": "YT"
    },
    {
      "label": "Mexico",
      "dial_code_label": "+52",
      "value": "52",
      "country_code": "MX"
    },
    {
      "label": "Micronesia, Federated States of Micronesia",
      "dial_code_label": "+691",
      "value": "691",
      "country_code": "FM"
    },
    {
      "label": "Moldova",
      "dial_code_label": "+373",
      "value": "373",
      "country_code": "MD"
    },
    {
      "label": "Monaco",
      "dial_code_label": "+377",
      "value": "377",
      "country_code": "MC"
    },
    {
      "label": "Mongolia",
      "dial_code_label": "+976",
      "value": "976",
      "country_code": "MN"
    },
    {
      "label": "Montenegro",
      "dial_code_label": "+382",
      "value": "382",
      "country_code": "ME"
    },
    {
      "label": "Montserrat",
      "dial_code_label": "+1664",
      "value": "1664",
      "country_code": "MS"
    },
    {
      "label": "Morocco",
      "dial_code_label": "+212",
      "value": "212",
      "country_code": "MA"
    },
    {
      "label": "Mozambique",
      "dial_code_label": "+258",
      "value": "258",
      "country_code": "MZ"
    },
    {
      "label": "Myanmar",
      "dial_code_label": "+95",
      "value": "95",
      "country_code": "MM"
    },
    {
      "label": "Namibia",
      "dial_code_label": "+264",
      "value": "264",
      "country_code": "NA"
    },
    {
      "label": "Nauru",
      "dial_code_label": "+674",
      "value": "674",
      "country_code": "NR"
    },
    {
      "label": "Nepal",
      "dial_code_label": "+977",
      "value": "977",
      "country_code": "NP"
    },
    {
      "label": "Netherlands",
      "dial_code_label": "+31",
      "value": "31",
      "country_code": "NL"
    },
    {
      "label": "Netherlands Antilles",
      "dial_code_label": "+599",
      "value": "599",
      "country_code": "AN"
    },
    {
      "label": "New Caledonia",
      "dial_code_label": "+687",
      "value": "687",
      "country_code": "NC"
    },
    {
      "label": "New Zealand",
      "dial_code_label": "+64",
      "value": "64",
      "country_code": "NZ"
    },
    {
      "label": "Nicaragua",
      "dial_code_label": "+505",
      "value": "505",
      "country_code": "NI"
    },
    {
      "label": "Niger",
      "dial_code_label": "+227",
      "value": "227",
      "country_code": "NE"
    },
    {
      "label": "Nigeria",
      "dial_code_label": "+234",
      "value": "234",
      "country_code": "NG"
    },
    {
      "label": "Niue",
      "dial_code_label": "+683",
      "value": "683",
      "country_code": "NU"
    },
    {
      "label": "Norfolk Island",
      "dial_code_label": "+672",
      "value": "672",
      "country_code": "NF"
    },
    {
      "label": "Northern Mariana Islands",
      "dial_code_label": "+1670",
      "value": "1670",
      "country_code": "MP"
    },
    {
      "label": "Norway",
      "dial_code_label": "+47",
      "value": "47",
      "country_code": "NO"
    },
    {
      "label": "Oman",
      "dial_code_label": "+968",
      "value": "968",
      "country_code": "OM"
    },
    {
      "label": "Pakistan",
      "dial_code_label": "+92",
      "value": "92",
      "country_code": "PK"
    },
    {
      "label": "Palau",
      "dial_code_label": "+680",
      "value": "680",
      "country_code": "PW"
    },
    {
      "label": "Palestinian Territory, Occupied",
      "dial_code_label": "+970",
      "value": "970",
      "country_code": "PS"
    },
    {
      "label": "Panama",
      "dial_code_label": "+507",
      "value": "507",
      "country_code": "PA"
    },
    {
      "label": "Papua New Guinea",
      "dial_code_label": "+675",
      "value": "675",
      "country_code": "PG"
    },
    {
      "label": "Paraguay",
      "dial_code_label": "+595",
      "value": "595",
      "country_code": "PY"
    },
    {
      "label": "Peru",
      "dial_code_label": "+51",
      "value": "51",
      "country_code": "PE"
    },
    {
      "label": "Philippines",
      "dial_code_label": "+63",
      "value": "63",
      "country_code": "PH"
    },
    {
      "label": "Pitcairn",
      "dial_code_label": "+64",
      "value": "64",
      "country_code": "PN"
    },
    {
      "label": "Poland",
      "dial_code_label": "+48",
      "value": "48",
      "country_code": "PL"
    },
    {
      "label": "Portugal",
      "dial_code_label": "+351",
      "value": "351",
      "country_code": "PT"
    },
    {
      "label": "Puerto Rico",
      "dial_code_label": "+1939",
      "value": "1939",
      "country_code": "PR"
    },
    {
      "label": "Qatar",
      "dial_code_label": "+974",
      "value": "974",
      "country_code": "QA"
    },
    {
      "label": "Romania",
      "dial_code_label": "+40",
      "value": "40",
      "country_code": "RO"
    },
    {
      "label": "Russia",
      "dial_code_label": "+7",
      "value": "7",
      "country_code": "RU"
    },
    {
      "label": "Rwanda",
      "dial_code_label": "+250",
      "value": "250",
      "country_code": "RW"
    },
    {
      "label": "Reunion",
      "dial_code_label": "+262",
      "value": "262",
      "country_code": "RE"
    },
    {
      "label": "Saint Barthelemy",
      "dial_code_label": "+590",
      "value": "590",
      "country_code": "BL"
    },
    {
      "label": "Saint Helena, Ascension and Tristan Da Cunha",
      "dial_code_label": "+290",
      "value": "290",
      "country_code": "SH"
    },
    {
      "label": "Saint Kitts and Nevis",
      "dial_code_label": "+1869",
      "value": "1869",
      "country_code": "KN"
    },
    {
      "label": "Saint Lucia",
      "dial_code_label": "+1758",
      "value": "1758",
      "country_code": "LC"
    },
    {
      "label": "Saint Martin",
      "dial_code_label": "+590",
      "value": "590",
      "country_code": "MF"
    },
    {
      "label": "Saint Pierre and Miquelon",
      "dial_code_label": "+508",
      "value": "508",
      "country_code": "PM"
    },
    {
      "label": "Saint Vincent and the Grenadines",
      "dial_code_label": "+1784",
      "value": "1784",
      "country_code": "VC"
    },
    {
      "label": "Samoa",
      "dial_code_label": "+685",
      "value": "685",
      "country_code": "WS"
    },
    {
      "label": "San Marino",
      "dial_code_label": "+378",
      "value": "378",
      "country_code": "SM"
    },
    {
      "label": "Sao Tome and Principe",
      "dial_code_label": "+239",
      "value": "239",
      "country_code": "ST"
    },
    {
      "label": "Saudi Arabia",
      "dial_code_label": "+966",
      "value": "966",
      "country_code": "SA"
    },
    {
      "label": "Senegal",
      "dial_code_label": "+221",
      "value": "221",
      "country_code": "SN"
    },
    {
      "label": "Serbia",
      "dial_code_label": "+381",
      "value": "381",
      "country_code": "RS"
    },
    {
      "label": "Seychelles",
      "dial_code_label": "+248",
      "value": "248",
      "country_code": "SC"
    },
    {
      "label": "Sierra Leone",
      "dial_code_label": "+232",
      "value": "232",
      "country_code": "SL"
    },
    {
      "label": "Singapore",
      "dial_code_label": "+65",
      "value": "65",
      "country_code": "SG"
    },
    {
      "label": "Slovakia",
      "dial_code_label": "+421",
      "value": "421",
      "country_code": "SK"
    },
    {
      "label": "Slovenia",
      "dial_code_label": "+386",
      "value": "386",
      "country_code": "SI"
    },
    {
      "label": "Solomon Islands",
      "dial_code_label": "+677",
      "value": "677",
      "country_code": "SB"
    },
    {
      "label": "Somalia",
      "dial_code_label": "+252",
      "value": "252",
      "country_code": "SO"
    },
    {
      "label": "South Africa",
      "dial_code_label": "+27",
      "value": "27",
      "country_code": "ZA"
    },
    {
      "label": "South Sudan",
      "dial_code_label": "+211",
      "value": "211",
      "country_code": "SS"
    },
    {
      "label": "South Georgia and the South Sandwich Islands",
      "dial_code_label": "+500",
      "value": "500",
      "country_code": "GS"
    },
    {
      "label": "Spain",
      "dial_code_label": "+34",
      "value": "34",
      "country_code": "ES"
    },
    {
      "label": "Sri Lanka",
      "dial_code_label": "+94",
      "value": "94",
      "country_code": "LK"
    },
    {
      "label": "Sudan",
      "dial_code_label": "+249",
      "value": "249",
      "country_code": "SD"
    },
    {
      "label": "Suriname",
      "dial_code_label": "+597",
      "value": "597",
      "country_code": "SR"
    },
    {
      "label": "Svalbard and Jan Mayen",
      "dial_code_label": "+47",
      "value": "47",
      "country_code": "SJ"
    },
    {
      "label": "Swaziland",
      "dial_code_label": "+268",
      "value": "268",
      "country_code": "SZ"
    },
    {
      "label": "Sweden",
      "dial_code_label": "+46",
      "value": "46",
      "country_code": "SE"
    },
    {
      "label": "Switzerland",
      "dial_code_label": "+41",
      "value": "41",
      "country_code": "CH"
    },
    {
      "label": "Syrian Arab Republic",
      "dial_code_label": "+963",
      "value": "963",
      "country_code": "SY"
    },
    {
      "label": "Taiwan",
      "dial_code_label": "+886",
      "value": "886",
      "country_code": "TW"
    },
    {
      "label": "Tajikistan",
      "dial_code_label": "+992",
      "value": "992",
      "country_code": "TJ"
    },
    {
      "label": "Tanzania, United Republic of Tanzania",
      "dial_code_label": "+255",
      "value": "255",
      "country_code": "TZ"
    },
    {
      "label": "Thailand",
      "dial_code_label": "+66",
      "value": "66",
      "country_code": "TH"
    },
    {
      "label": "Timor-Leste",
      "dial_code_label": "+670",
      "value": "670",
      "country_code": "TL"
    },
    {
      "label": "Togo",
      "dial_code_label": "+228",
      "value": "228",
      "country_code": "TG"
    },
    {
      "label": "Tokelau",
      "dial_code_label": "+690",
      "value": "690",
      "country_code": "TK"
    },
    {
      "label": "Tonga",
      "dial_code_label": "+676",
      "value": "676",
      "country_code": "TO"
    },
    {
      "label": "Trinidad and Tobago",
      "dial_code_label": "+1868",
      "value": "1868",
      "country_code": "TT"
    },
    {
      "label": "Tunisia",
      "dial_code_label": "+216",
      "value": "216",
      "country_code": "TN"
    },
    {
      "label": "Turkey",
      "dial_code_label": "+90",
      "value": "90",
      "country_code": "TR"
    },
    {
      "label": "Turkmenistan",
      "dial_code_label": "+993",
      "value": "993",
      "country_code": "TM"
    },
    {
      "label": "Turks and Caicos Islands",
      "dial_code_label": "+1649",
      "value": "1649",
      "country_code": "TC"
    },
    {
      "label": "Tuvalu",
      "dial_code_label": "+688",
      "value": "688",
      "country_code": "TV"
    },
    {
      "label": "Uganda",
      "dial_code_label": "+256",
      "value": "256",
      "country_code": "UG"
    },
    {
      "label": "Ukraine",
      "dial_code_label": "+380",
      "value": "380",
      "country_code": "UA"
    },
    {
      "label": "United Arab Emirates",
      "dial_code_label": "+971",
      "value": "971",
      "country_code": "AE"
    },
    {
      "label": "United Kingdom",
      "dial_code_label": "+44",
      "value": "44",
      "country_code": "GB"
    },
    {
      "label": "United States",
      "dial_code_label": "+1",
      "value": "1",
      "country_code": "US"
    },
    {
      "label": "Uruguay",
      "dial_code_label": "+598",
      "value": "598",
      "country_code": "UY"
    },
    {
      "label": "Uzbekistan",
      "dial_code_label": "+998",
      "value": "998",
      "country_code": "UZ"
    },
    {
      "label": "Vanuatu",
      "dial_code_label": "+678",
      "value": "678",
      "country_code": "VU"
    },
    {
      "label": "Venezuela, Bolivarian Republic of Venezuela",
      "dial_code_label": "+58",
      "value": "58",
      "country_code": "VE"
    },
    {
      "label": "Vietnam",
      "dial_code_label": "+84",
      "value": "84",
      "country_code": "VN"
    },
    {
      "label": "Virgin Islands, British",
      "dial_code_label": "+1284",
      "value": "1284",
      "country_code": "VG"
    },
    {
      "label": "Virgin Islands, U.S.",
      "dial_code_label": "+1340",
      "value": "1340",
      "country_code": "VI"
    },
    {
      "label": "Wallis and Futuna",
      "dial_code_label": "+681",
      "value": "681",
      "country_code": "WF"
    },
    {
      "label": "Yemen",
      "dial_code_label": "+967",
      "value": "967",
      "country_code": "YE"
    },
    {
      "label": "Zambia",
      "dial_code_label": "+260",
      "value": "260",
      "country_code": "ZM"
    },
    {
      "label": "Zimbabwe",
      "dial_code_label": "+263",
      "value": "263",
      "country_code": "ZW"
    }
  ];

export const footerList = [
  {
    "title": "Citigroup.com",
    "link": "https://www.citigroup.com/global",
  },
  {
    "title": "Cookie Policy",
    "link": "https://www.citigroup.com/global/institutional-clients/cookiepolicy",
  },
  {
    "title": "Privacy",
    "link": "https://www.citigroup.com/global/privacy",
  },
  {
    "title": "Notice at collection",
    "link": "https://www.citigroup.com/global/privacy#a",
  },
  {
    "title": "CA Privacy Hub",
    "link": "https://online.citi.com/US/ag/dataprivacyhub/cpra/home",
  },
  {
    "title": "Terms And Condition",
    "link": "https://www.citigroup.com/global/terms",
  }];
